import React from 'react';
import { DataTableColumn } from '../../../../Base/Components/DataTable/DataTable';
import FormattedDate from '../../../../../Components/FormattedDate';
import { QueryDataItem } from '../../../../../Interfaces/QueryDataItem';
import { DoctorSickLeavesQuery } from '../../../../../graphql/graphql';
import ManagerSickLeaveStatus from './ManagerSickLeaveStatus';
import ManagerSickLeaveMoneyTicketConfirmationCell from './ManagerSickLeaveMoneyTicketConfirmationCell';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

type Row = QueryDataItem<DoctorSickLeavesQuery['documents']>;

export interface ManagerSickLeavesTableHandle {
	refresh: () => void;
	openDetail: (item: Row) => void;
}

export const ManagerSickLeavesDefaultColumns: DataTableColumn<
	Row,
	ManagerSickLeavesTableHandle
>[] = [
	{
		key: 'createdAt',
		label: 'component.managerSickLeaves.tableCreatedAt',
		visible: true,
		renderItem: (item: Row) =>
			item.createdAt ? <FormattedDate date={item.createdAt} /> : <span />,
	},
	{
		key: 'patient',
		label: 'component.managerSickLeaves.tablePatient',
		bold: true,
		visible: true,
		renderItem: (item: Row) => {
			return <span>{item.user?.profile?.fullName || ''}</span>;
		},
	},
	{
		key: 'diagnosis',
		label: 'component.managerSickLeaves.tableDiagnosis',
		visible: true,
		renderItem: (item: Row) => {
			const sickLeaveData = item.items?.find(i => i.type === 'sickLeaveData');
			return (
				<span>{sickLeaveData?.extra?.data?.sickLeave?.diagnosis || ''}</span>
			);
		},
	},
	{
		key: 'decisionNumber',
		label: 'component.managerSickLeaves.tableDecisionNumber',
		visible: true,
		renderItem: (item: Row) => <span>{item.code || ''}</span>,
	},
	{
		key: 'moneyTicket',
		label: 'component.CSSZSickLeaveCertificateDetail.moneySlipToIssue',
		visible: true,
		renderItem: (item: Row) => (
			<ManagerSickLeaveMoneyTicketConfirmationCell row={item} />
		),
	},
	{
		key: 'doctor',
		label: 'component.managerSickLeaves.tableDoctor',
		visible: true,
		renderItem: (item: Row) => (
			<span>{item.createdBy?.profile?.fullName || ''}</span>
		),
	},
	{
		key: 'status',
		label: 'component.managerSickLeaves.tableStatus',
		visible: true,
		renderItem: (item: Row) => {
			const sickLeaveData = item.items?.find(i => i.type === 'sickLeaveData');
			return <ManagerSickLeaveStatus status={sickLeaveData?.extra?.status} />;
		},
	},
	{
		key: 'openDetail',
		label: 'base.shared.show',
		visible: true,
		renderItem: (item: Row, table: ManagerSickLeavesTableHandle) => (
			<LinkButton
				title='base.shared.show'
				theme={Theme.BLUE}
				onClick={() => table.openDetail(item)}
			/>
		),
	},
];
